import { LeadWillingness } from '../domain/types';

export const leadWillingnessLabels: {
  [key in LeadWillingness]: string;
} = {
  NOW: 'Immediatamente',
  IN_6_MONTHS: 'Entro 6 mesi',
  UNKNOWN: 'Oltre 6 mesi / Non sa',
};
